import moment from "moment-timezone";

export const formatDateTime = (date, format = null) => {
  if (date === null) {
    return null;
  }

  const actualFormat = format || "YYYY-MM-DD HH:mm:ss";
  return moment.tz(date, "Asia/Seoul").format(actualFormat);
};
